module.exports = __webpack_public_path__ + "img/orderVip.ec963945.png";